<script>
import Vue from 'vue'
import axios from 'axios'
import toast from '@utils/request-message'
import dsthPlanSubscription from 'dsth-plan-subscription'
import { merchantComputed } from '@state/helpers'
import { Loading } from 'element-ui'

Vue.use(dsthPlanSubscription)

export default {
  page() {
    return {
      title: '商家註冊',
    }
  },
  computed: {
    ...merchantComputed,
  },
  methods: {
    async tryToRegisterMerchant(data) {
      const loading = Loading.service({ text: '帳戶建立中，請稍候' })
      try {
        await axios.post(
          '/user/checkEmail',
          { email: data.email },
          { customErrorHandle: this.checkEmailErrorHandle }
        )
      } catch (error) {
        loading.close()
        return
      }
      try {
        await axios.post(
          '/merchant/checkAlias',
          { alias: data.merchantAlias },
          { customErrorHandle: this.checkAliasErrorHandle }
        )
      } catch (error) {
        loading.close()
        return
      }
      try {
        const res = await this.$store.dispatch(
          'merchant/registerMerchant',
          data
        )
        loading.close()
        this.redirectToFinish(res, data)
      } catch {
        loading.close()
      }
    },
    checkEmailErrorHandle() {
      toast.error('已存在相同的電子信箱')
    },
    checkAliasErrorHandle() {
      toast.error('已存在相同的商店英文簡寫')
    },
    redirectToFinish(res, data) {
      let today = new Date()
      let newDate = new Date(today.setMonth(today.getMonth() + 1))
      let dd1 = String(newDate.getDate()).padStart(2, '0')
      let mm1 = String(newDate.getMonth() + 1).padStart(2, '0') // January is 0!
      let yyyy1 = newDate.getFullYear()
      let new_date = yyyy1 + '/' + mm1 + '/' + dd1

      localStorage['new_date'] = new_date
      localStorage['dd'] = dd1
      localStorage['mm'] = mm1

      localStorage['alias'] = res.items.alias
      localStorage['price'] = data.plan.total
      localStorage['period'] = data.period === 'month' ? 'monthly' : data.period
      window.location.href = 'register-done'
    },
    cancelUpdatePlan() {
      window.location.href = '/'
    },
  },
}
</script>

<template>
  <div
    :style="`background: white; min-height: 100vh;background-image: url(${require(`@assets/images/v2-bg4.png`)});background-size: cover;
    background-position: center;`"
  >
    <img
      style="

        width: 180px;
        margin: 30px;
        vertical-align: bottom;
        vertical-align: bottom;
      "
      :src="require(`@assets/images/logo.svg`)"
      alt
    />
    <EditPlan
      id="edit-plan"
      :plans-info="planList"
      @done="tryToRegisterMerchant"
      @leave="cancelUpdatePlan"
    ></EditPlan>
  </div>
</template>
<style lang="scss">
@import '~normalize.css/normalize.css';

// Design variables and utilities from src/design.
@import '@design-subscription';
@import '@src/design/subscription/global.scss';

// Custom style for element-ui
@import '@src/design/subscription/element-variables.scss';

*,
*::before,
*::after {
  box-sizing: border-box;
}
::-webkit-scrollbar {
  display: none;
}
html {
  font-size: 14px;
  line-height: 1.15;
  -webkit-tap-highlight-color: transparent;
}
body {
  @extend %font-content;

  height: 100vh;
  background: $color-body-bg;
  -webkit-overflow-scrolling: touch;
}

// ===
// Base element styles
// ===

a,
a:visited {
  color: $color-link-text;
}

ul {
  padding: 0;
  margin: 0;
  list-style: none;
}
h1 {
  @extend %font-heading;

  font-size: ms(6);
  letter-spacing: $font-letter-spacing-base;
}

h2 {
  @extend %font-heading;

  font-size: ms(5);
  letter-spacing: $font-letter-spacing-base;
}

h3 {
  @extend %font-heading;

  font-size: ms(4);
  margin-block-start: ms(4) / 1.5;
  margin-block-end: ms(4) / 1.5;
  letter-spacing: $font-letter-spacing-base;
}

h4 {
  @extend %font-heading;

  font-size: ms(3);
  margin-block-start: ms(3) / 1.5;
  margin-block-end: ms(3) / 1.5;
  letter-spacing: $font-letter-spacing-base;
}

h5 {
  @extend %font-heading;

  font-size: ms(2);
  margin-block-start: ms(2) / 1.5;
  margin-block-end: ms(2) / 1.5;
  letter-spacing: $font-letter-spacing-small;
}

h6 {
  @extend %font-heading;

  font-size: ms(1);
  margin-block-start: ms(1) / 1.5;
  margin-block-end: ms(1) / 1.5;
  letter-spacing: $font-letter-spacing-small;
}

input {
  background: none;
}

img {
  max-width: 100%;
}

[hidden] {
  display: none;
}

/* */

#edit-plan {
  .flex-space {
    .title {
      margin-bottom: 0;
      font-size: 14px;
    }
  }
  .el-steps.el-steps--simple {
    .el-step__icon.is-text {
      vertical-align: middle;
    }
    .el-step__title.is-process {
      font-weight: inherit;
    }
  }
  .footer {
    padding: inherit;
  }
  .checkout {
    .details {
      .total {
        line-height: 1.15;
      }
    }
  }
}
</style>
